import { MutationTree } from 'vuex';
import { CartState } from './types';
import { ICart } from '@resclick/data-access';

export const mutations: MutationTree<CartState> = {
  addToCart(state, payload: ICart['products'][number]) {
    state.products.push(payload);
  },
  removeFromCart(state, payload) {
    state.products.splice(payload, 1);
  },
  setLoading(state, payload: boolean) {
    state.isLoading = payload;
  },
  setCart(state, payload: ICart) {
    Object.assign(state, payload);
    if (!state.customer?.address) {
      state.customer.address = {};
    }
    if (!state.invoice?.address) {
      state.invoice.address = {};
    }

    state.isLoading = false;
    window.localStorage.setItem('cartId', payload.id as string);
  },
  clearCart(state) {
    Object.assign(state, { customer: {}, invoice: {}, products: {} });
  },
  setPromotionCode(state, payload: string) {
    state.promotionCode = payload;
  },
};
